import { GeocodeService } from './../../model/services/geocode.service';
import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
export type MapBoxPlace = {
  place_name:string,
  center:[number,number],
  bbox:[number,number,number]
}
@Component({
  selector: 'app-address-finder',
  templateUrl: './address-finder.component.html',
  styleUrls: ['./address-finder.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class AddressFinderComponent implements OnInit {
  public results:Array<MapBoxPlace> = [];
  public address = '';
  public attribution = '';
  public searchTerm = '';

  @Output() selections = new EventEmitter<MapBoxPlace>();

  constructor(private cdr:ChangeDetectorRef, private locSvc: GeocodeService) { }

  ngOnInit(): void {
  }
  Search(event:KeyboardEvent) {
    if(!event ) return;
    if(!event.target) return;
    this.searchTerm = (event.target as HTMLInputElement).value.trim();
    this.results = [];
    this.address = '';
    this.cdr.detectChanges();
    const obs = this.locSvc.Search(this.searchTerm,{});
    obs.toPromise().then((value:any)=>{
      if(!value) return;
      this.results = value.features;
      if(!this.results) this.results = [];
      this.attribution = value.attribution;
      this.cdr.detectChanges();
    });
  }
  SelectAddress(address:MapBoxPlace) {
    this.selections.emit(address);
    this.results = [];
    this.address = '';
    this.searchTerm = '';
    this.cdr.detectChanges();
  }


}
